export const SCAN_COMPROBANTE_COBRANZA = `
  mutation ScanComprobanteCobranza($file: Upload!, $sucursalId: ID!) {
    scanComprobanteCobranza(file: $file, sucursalId: $sucursalId) {
      rawText
      warnings
      suggested {
        fecha { value confidence }
        importe { value confidence }
        medioPago { value confidence }
        referencia { value confidence }
        cuit { value confidence }
        clienteNombre { value confidence }
        banco { value confidence }
        numeroCheque { value confidence }
        fechaEmision { value confidence }
        fechaCobro { value confidence }
      }
    }
  }
`;
